import React from "react";
import InfoBox from "./InfoBox";
import "./Popup.scss";

const Popup = ({
  isPopupVisible,
  closePopup,
  currentContentIndex, // **使用 popupContentIndex**
  setCurrentContentIndex,
  isLoading,
  setIsLoading,
  handleSubmit,
}) => {
  if (!isPopupVisible) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <InfoBox
          currentContentIndex={currentContentIndex}
          setCurrentContentIndex={setCurrentContentIndex}
          onClose={closePopup}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          handleSubmit={handleSubmit}
          nextContent={() => setCurrentContentIndex(1)}
        />
      </div>
    </div>
  );
};

export default Popup;
